export const visit = (vm, at) => {
at({ "de": { "pricingPage": { "detailedTermSelector": { "payMonthly": "Monatlich zahlen", "payAnnually": "J\xE4hrlich zahlen", "commitMonthly": "Monatlich verpflichten", "commitAnnually": "J\xE4hrlich verpflichten", "bestValue": "Bestes Angebot" } } } });
};